import { AreaDescriptions } from './general-parameters/areaDescriptions'
import { AuditLogs } from './general-parameters/auditLogs'
import { CoordinatorProfiles } from './general-parameters/coordinatorProfiles'
import { Courses } from './general-parameters/courses'
import { EADTools } from './general-parameters/eadTools'
import { EducationLevels } from './general-parameters/educationLevels'
import { emailNotifications } from './general-parameters/emailNotifications'
import { ExternalTools } from './general-parameters/externalTools'
import { GeneralParams } from './general-parameters/generalParams'
import { Modalities } from './general-parameters/modalities'
import { TeacherProfiles } from './general-parameters/teacherProfiles'
import { Units } from './general-parameters/units'
import { YearExercises } from './general-parameters/yearExercises'
import { AdminHome } from './home'
import { InstitutionColors } from './institutionColors'
import { InstitutionLogo } from './institutionLogo'
import { Equivalencies } from './more/equivalencies'
import { Users } from './more/users'
import { BibliographyTypes } from './pedagogical-parameters/bibliographyTypes'
import { BloxProfiles } from './pedagogical-parameters/bloxProfiles'
import { Competences } from './pedagogical-parameters/competences'
import { Corequirements } from './pedagogical-parameters/corequirements'
import { Equivalances } from './pedagogical-parameters/equivalences'
import { FunctionalAreas } from './pedagogical-parameters/functionalAreas'
import { KnowledgeAreas } from './pedagogical-parameters/knowledgeAreas'
import { LevelEducation } from './pedagogical-parameters/levelEducation'
import { MatrixCurriculum } from './pedagogical-parameters/matrixCurriculum'
import { Methodologies } from './pedagogical-parameters/methodologies'
import { PedagogicalParams } from './pedagogical-parameters/pedagogicalParams'
import { Requirements } from './pedagogical-parameters/requirements'
import { TeachingApproach } from './pedagogical-parameters/teachingApproach'
import { TeachingPlan } from './pedagogical-parameters/teachingPlan'

export default {
  AdminHome,
  InstitutionLogo,
  InstitutionColors,
  KnowledgeAreas,
  FunctionalAreas,
  Requirements,
  Corequirements,
  Competences,
  Methodologies,
  BibliographyTypes,
  BloxProfiles,
  AreaDescriptions,
  Modalities,
  EADTools,
  CoordinatorProfiles,
  TeacherProfiles,
  Units,
  Courses,
  EducationLevels,
  Equivalencies,
  Users,
  TeachingPlan,
  YearExercises,
  AuditLogs,
  PedagogicalParams,
  GeneralParams,
  emailNotifications,
  MatrixCurriculum,
  TeachingApproach,
  LevelEducation,
  Equivalances,
  ExternalTools,
}
